import React from 'react';
import {PlayersList as BasePlayersList} from 'desktop/sports/nfl/players-list/single-game';
import {connect} from "react-redux";

class PlayersList extends BasePlayersList {
    getSharpPointsCell(params = {}) {
        return null;
    }
    getSharpPointsHeader() {
        return null;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        reset,
        playersLock,
        playersData: {
            players,
            filters,
        },
        userPointsType,
        modesConfig,
    } = state;

    return {
        players,
        playersFilter: filters,
        playersLock,
        sportConfig,
        reset,
        userPointsType,
        modesConfig,
    };
}

const Table = connect(mapStatesToProps)(PlayersList);

export {Table};
